module.exports = __webpack_public_path__ + "img/kc-logo.ee6d861c.png";